import React, { useContext, useCallback, useState , useRef} from 'react';
import { Tooltip } from 'antd';

import { PageElementsContext } from '../../../context/pageElementsContext';
import { ColumnResizer } from '../styles';

const GridFormatting = (props) => {

  const [isLeft, toggleLeft] = useState(true);

  const { itemUUID, setSelectedRange, setSelectedCell, setContextMenu, rowIndex, extraStyles = {}, containerStyles = {} } = props;
  const { updateComplexElementDetails } = useContext(PageElementsContext);

  const ref = useRef(null);

  const onAddRow = useCallback((e) => {
    const isTop = e.currentTarget.id.includes('first');
    let rowIndex = 0;
    if (!isTop) {
      rowIndex = parseInt(e.currentTarget.id.replaceAll(`add-row-${itemUUID}-`, ''), 10);
    }
    updateComplexElementDetails(
      itemUUID,
      {
        index: rowIndex,
        isTop,
        isBlock: true,
      },
      'static-table-add-row'
    );
    setSelectedRange(undefined);
    setSelectedCell(undefined);
    setContextMenu(false);
  }, []);

  const onMouseOver = useCallback((e) => {
    e.persist();
    const bounds = ref.current?.getBoundingClientRect();
    toggleLeft(previousValue => {
      return e.nativeEvent.clientX < (bounds?.left + (bounds?.width / 2));
    });
  }, []);

  return (
      <ColumnResizer ref={ref} left={0} leftStart={2} isStatic={true} className={'resizer'} horizontal={true} top={-3}
        style={containerStyles} onMouseOver={onMouseOver}>
          <Tooltip
            title={"Add Row"}
          >
            <div className={`addColumnOptions hoverButton ${isLeft ? 'left' : 'right'}`}
              id={`add-row-${itemUUID}-${rowIndex}`}
              style={{ top: '-10px', ...extraStyles }}
              onClick={onAddRow}
            >
              +
            </div>
          </Tooltip>
      </ColumnResizer>
  )
}

export default GridFormatting;